export const orderStatusMap = {
  nova: 'Aguardando confirmação de pagamento',
  paga: 'Pagamento confirmado',
  'em produção': 'Em produção',
  enviada: 'Enviado',
  entregue: 'Entregue',
  concluída: 'Finalizado',
  cancelada: 'Cancelado',
};
